module.exports = __webpack_public_path__ + "static/img/tb001.6cff54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tools/wodistant/tb001.png
// module id = V5f6
// module chunks = 1